export const PokemonPageURL = "/:meta/:league/:speciesId";
